'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var _threadGetters = require('../../thread/operators/threadGetters');

var _KeyPaths = require('../../thread/constants/KeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPreviewText = function getPreviewText(conversation) {
  return (0, _pubnubMessageGetters.getText)((0, _threadGetters.getLatestMessage)(conversation)) || (0, _getIn2.default)(_KeyPaths.LATEST_EMAIL_SUBJECT, conversation);
};

exports.default = getPreviewText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/conversation/getPreviewText.js
// module id = 842
// module chunks = 2 3